import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.error('[supabase] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY in .env');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});

// Expose for browser-console debugging (admin diagnostics only)
if (typeof window !== 'undefined') {
  window.supabase = supabase;
}

/* ——————————————————————————————————————————————————————————————————
   Column <-> field mapping
   DB (snake_case) ↔ App (camelCase) — pages expect camelCase keys
   (same shape as Firebase Firestore docs had)
—————————————————————————————————————————————————————————————————— */
export function dbUserToAppUser(row) {
  if (!row) return null;
  return {
    uid: row.id, // alias — many legacy pages use user.uid
    id: row.id,
    email: row.email,
    name: row.name,
    avatar: row.avatar,
    phone: row.phone,
    role: row.role || 'student',
    title: row.title || 'Eager Explorer',
    location: row.location || '',
    bio: row.bio || '',
    interests: row.interests || [],
    skills: row.skills || [],
    projects: row.projects || [],
    savedColleges: row.saved_colleges || [],
    applications: row.applications || [],
    academic: row.academic || { marks10: '', marks12: '', cgpaUG: '', cgpaPG: '', stream: '', state: '' },
    quizResult: row.quiz_result,
    quizAttempts: row.quiz_attempts || 0,
    eagerScore: row.eager_score || 0,
    badges: row.badges || ['Newcomer'],
    referralCount: row.referral_count || 0,
    stats: row.stats || { profileViews: 0, shortlisted: 0, applications: 0 },
    scoutMode: row.scout_mode || false,
    lastAcknowledgedAt: row.last_acknowledged_at,
    joinedAt: row.joined_at || new Date().toISOString(),
    level: 1,
    photoURL: row.avatar,
    displayName: row.name,
  };
}

// App (camelCase) -> DB (snake_case) for updates
export function appUpdateToDbUpdate(patch) {
  const map = {
    name: 'name',
    avatar: 'avatar',
    phone: 'phone',
    role: 'role',
    title: 'title',
    location: 'location',
    bio: 'bio',
    interests: 'interests',
    skills: 'skills',
    projects: 'projects',
    savedColleges: 'saved_colleges',
    applications: 'applications',
    academic: 'academic',
    quizResult: 'quiz_result',
    quizAttempts: 'quiz_attempts',
    eagerScore: 'eager_score',
    badges: 'badges',
    referralCount: 'referral_count',
    stats: 'stats',
    scoutMode: 'scout_mode',
    lastAcknowledgedAt: 'last_acknowledged_at',
  };
  const out = {};
  for (const k of Object.keys(patch)) {
    if (map[k]) out[map[k]] = patch[k];
  }
  out.updated_at = new Date().toISOString();
  return out;
}
